import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf, NgStyle, NgFor} from '@angular/common';
import {CardButtonComponent} from '../card-button/card-button.component';
import {InteractionAnswerSaveDto} from '../../models/card.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-roleplay',
  templateUrl: './card-roleplay.component.html',
  styleUrls: ['./card-roleplay.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, NgFor, CardButtonComponent, TranslateModule],
})
export class CardRoleplayComponent implements OnInit {
  @Output() onPlayFinished = new EventEmitter<boolean>();

  @Input() videos: string[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  play() {
    const listenBtn = document.getElementById('listenBtn');
    if (listenBtn) {
      listenBtn.style.display = 'none';
    }

    let currentIndex = 0;

    const playNextVideo = () => {
      if (currentIndex < this.videos.length) {
        const videoId = `roleplay${currentIndex}`;
        const wrapperId = `videoWrapper${currentIndex}`;

        const video = document.getElementById(videoId) as HTMLMediaElement;
        const wrapper = document.getElementById(wrapperId);

        if (video && wrapper) {
          video.play();
          wrapper.classList.add('playing');

          video.addEventListener('ended', () => {
            wrapper.classList.remove('playing');
            currentIndex++;
            playNextVideo();
          }, {once: true});
        }
      } else {
        document.getElementById('videoContainer')?.classList.add('finished');
        document.getElementById('replayButton')?.classList.add('show');
        this.onPlayFinished.emit(true);
      }
    };

    playNextVideo();
  }

  replay() {
    document.getElementById('videoContainer')?.classList.remove('finished');
    document.getElementById('replayButton')?.classList.remove('show');
    this.play();
  }
}
